import type { Dayjs } from 'dayjs';
import type { Feature, Point } from 'geojson';
import { getYesterdayCalendarDate } from '@features/regional-overview/utils/current-calendar-date.utils';
import type { RegionalOverviewDigitalTrapsProperties } from 'querys/regional-overview/regional-overview.query.models';
import { create } from 'zustand';
import type { TrapGroup } from './domain';

interface DigitalTrapsState {
  isLoading?: boolean;
  setIsLoading: (loading: boolean) => void;

  selectedDate: Dayjs;
  setSelectedDate: (date: Dayjs) => void;

  allTrapGroups: TrapGroup[];
  setAllTrapGroups: (trapGroups: TrapGroup[]) => void;

  trapGroups: TrapGroup[];
  setTrapGroups: (trapGroups: TrapGroup[]) => void;
  totalOfTraps: number;
  setTotalOfTraps: (total: number) => void;

  selectedTrapId?: string;
  selectedTrap?: Feature<Point, RegionalOverviewDigitalTrapsProperties>;
  setSelectedTrapId: (trapId?: string) => void;
  setSelectedTrap: (trap?: Feature<Point, RegionalOverviewDigitalTrapsProperties>) => void;
}

export const useDigitalTrapsStore = create<DigitalTrapsState>()(set => ({
  isLoading: false,
  setIsLoading: loading => set({ isLoading: loading }),

  selectedDate: getYesterdayCalendarDate(),
  setSelectedDate: date => set({ selectedDate: date }),

  allTrapGroups: [],
  setAllTrapGroups: trapGroups => set({ allTrapGroups: trapGroups }),

  trapGroups: [],
  setTrapGroups: trapGroups => set({ trapGroups: trapGroups }),
  totalOfTraps: 0,
  setTotalOfTraps: total => set({ totalOfTraps: total }),

  selectedTrapId: undefined,
  selectedTrap: undefined,
  setSelectedTrapId: trapId => set({ selectedTrapId: trapId }),
  setSelectedTrap: trap => set({ selectedTrap: trap })
}));
